import { useLocale } from 'next-intl';
import { usePathname } from 'next/navigation';
import { Locale } from '../../../../i18n/constants';
import { slugToRoute, StepRoute } from '../../../../i18n/pathnames/licenses';

/**
 * Derives the current license flow step slug from the pathname.
 * Returns null when required routing context (locale, licenseType, pathname) is missing.
 * Root (no trailing segment) maps to '/'.
 */
export const useCurrentStepRoute = (): StepRoute | null => {
  const pathname = usePathname();
  const locale = useLocale() as Locale;

  if (!pathname) return null;

  // Handle potential trailing slashes by taking the last non-empty segment.
  const lastSegment = pathname.split('/').filter(Boolean).pop();
  if (!lastSegment) return null;

  return (slugToRoute(lastSegment, locale) as StepRoute | undefined) ?? null;
};
